export const legalHrGettingStartedArticle = {
  title: 'Legal & HR Document Hub: Getting Started',
  slug: 'legal-hr-getting-started',
  content: `Legal & HR Document Hub: Getting Started

Access legal and HR generators from one dashboard.

1) Open Legal & HR
- Go to /legal-hr.

2) Choose a tool card
- Contract Analyzer
- Privacy Policy Generator
- Terms & Conditions Generator
- Employee Handbook Creator
- Non-Disclosure Agreement (NDA)
- Contractor Agreement
- HR Policy Generator

3) Launch a tool
- Click the card to open its workflow.
- Some tools are marked Beta or Coming Soon.
`,
};
